import { render, staticRenderFns } from "./Accounts.vue?vue&type=template&id=04eab0d1&scoped=true"
import script from "./Accounts.vue?vue&type=script&lang=ts"
export * from "./Accounts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04eab0d1",
  null
  
)

export default component.exports